import { register } from "async-ops";
import { callMvcApi  } from "../../../../call-web-api";
export const GET_REMIT_LINE_LEVEL_ADJUSTMENT_DETAILS = 'GET_REMIT_LINE_LEVEL_ADJUSTMENT_DETAILS';

export const service = async (data) => {
    const options: object = {
      url: `/api/Remit/GetLineLevelAdjustmentDetail/` + data.caseDetailId,
      method: "GET",
    };
    const response = callMvcApi(options);
    return response;
  };

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_REMIT_LINE_LEVEL_ADJUSTMENT_DETAILS, service, mock);
